import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.scripts');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-scripts',
template: templateSource || '',
    styles: [``],
})
export class PageKieraScriptsComponent implements OnInit {
    public scripts: any[] = [];
    public attachments: any[] = [];
    public showNewScript: boolean = false;
    public editScript: any = null;
    public newScriptName: string = '';
    public selectedFile: File | null = null;

    // Sorting (scripts table)
    public sortField: string = 'name';
    public sortDir: string = 'asc';

    // Sorting (attachments table)
    public attSortField: string = 'src_file_name';
    public attSortDir: string = 'asc';

    // Deploy modal
    public showDeploy: boolean = false;
    public deployScript: any = null;
    public deployNodes: any[] = [];
    public deployNodeIp: string = '';
    public deploySshUser: string = 'root';
    public deploySshPassword: string = '';
    public deployEnvVars: string = '';
    public deployLoading: boolean = false;
    public deployOutput: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("search");
        if (code === 200) {
            this.scripts = data.scripts || [];
            this.attachments = data.attachments || [];
            this.sortScripts();
            this.sortAttachments();
        }
        await this.service.render();
    }

    public async createScript() {
        if (!this.newScriptName) return;
        const { code, data } = await wiz.call("create", { name: this.newScriptName });
        if (code === 200) {
            this.showNewScript = false;
            const createdName = this.newScriptName;
            this.newScriptName = '';
            await this.load();
            const newScript = this.scripts.find((s: any) => s.name === createdName);
            if (newScript) this.openEditor(newScript);
            await this.service.render();
        }
    }

    public async deleteScript(id: number) {
        if (!confirm("Are you sure you want to delete this script?")) return;
        const { code } = await wiz.call("delete", { id });
        if (code === 200) await this.load();
    }

    public openEditor(script: any) {
        this.editScript = { ...script };
    }

    public async saveScript() {
        if (!this.editScript) return;
        const { code } = await wiz.call("update", { id: this.editScript.id, data: JSON.stringify(this.editScript) });
        if (code === 200) {
            this.editScript = null;
            await this.load();
        }
    }

    public onFileSelected(event: any) {
        const files = event.target.files;
        if (files && files.length > 0) {
            this.selectedFile = files[0];
        }
        this.service.render();
    }

    public async uploadAttachment(fileInput: any) {
        if (!this.selectedFile) return;

        const formData = new FormData();
        formData.append('file', this.selectedFile);

        const response = await fetch('/wiz/api/page.kiera.scripts/upload_attachment', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        });
        const result = await response.json();

        if (result.code === 200) {
            this.selectedFile = null;
            if (fileInput) fileInput.value = '';
            await this.load();
        }
    }

    public async deleteAttachment(id: number) {
        if (!confirm("Delete this attachment?")) return;
        const { code } = await wiz.call("delete_attachment", { id });
        if (code === 200) await this.load();
    }

    public formatSize(bytes: number): string {
        if (!bytes || bytes === 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + units[i];
    }

    // ===== Script Sorting =====
    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDir = 'asc';
        }
        this.sortScripts();
        await this.service.render();
    }

    private sortScripts() {
        const field = this.sortField;
        const dir = this.sortDir === 'asc' ? 1 : -1;
        this.scripts.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (field === 'id') return (Number(va) - Number(vb)) * dir;
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getSortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }

    // ===== Attachment Sorting =====
    public async sortAtt(field: string) {
        if (this.attSortField === field) {
            this.attSortDir = this.attSortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.attSortField = field;
            this.attSortDir = 'asc';
        }
        this.sortAttachments();
        await this.service.render();
    }

    private sortAttachments() {
        const field = this.attSortField;
        const dir = this.attSortDir === 'asc' ? 1 : -1;
        this.attachments.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (field === 'id' || field === 'size') return (Number(va) - Number(vb)) * dir;
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getAttSortIcon(field: string): string {
        if (this.attSortField !== field) return 'bx-sort-alt-2';
        return this.attSortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }

    // ===== Deploy Script =====
    public async openDeploy(script: any) {
        this.deployScript = script;
        this.deployNodeIp = '';
        this.deploySshUser = 'root';
        this.deploySshPassword = '';
        this.deployEnvVars = '';
        this.deployOutput = '';
        this.deployLoading = false;
        this.showDeploy = true;

        // Load nodes with IP
        const { code, data } = await wiz.call("nodes_for_deploy");
        if (code === 200) {
            this.deployNodes = data || [];
        }
        await this.service.render();
    }

    public closeDeploy() {
        this.showDeploy = false;
        this.deployScript = null;
        this.deployOutput = '';
    }

    public selectDeployNode(node: any) {
        this.deployNodeIp = node.ip_address;
        this.service.render();
    }

    public async executeDeploy() {
        if (!this.deployNodeIp) { alert('Select or enter a target node IP'); return; }
        if (!this.deploySshPassword) { alert('SSH Password is required'); return; }
        if (!confirm(`Execute "${this.deployScript.name}" on ${this.deployNodeIp}?`)) return;

        this.deployLoading = true;
        this.deployOutput = 'Executing script...';
        await this.service.render();

        const { code, data } = await wiz.call("deploy_script", {
            script_id: this.deployScript.id,
            node_ip: this.deployNodeIp,
            ssh_user: this.deploySshUser,
            ssh_password: this.deploySshPassword,
            env_vars: this.deployEnvVars
        });

        this.deployLoading = false;
        if (code === 200) {
            this.deployOutput = data.output || 'Completed (no output)';
            if (data.stderr) this.deployOutput += '\n\n--- STDERR ---\n' + data.stderr;
        } else {
            this.deployOutput = `Error: ${data?.message || 'Execution failed'}`;
            if (data?.output) this.deployOutput += '\n\n--- STDOUT ---\n' + data.output;
            if (data?.stderr) this.deployOutput += '\n\n--- STDERR ---\n' + data.stderr;
        }
        await this.service.render();
    }
}

export default PageKieraScriptsComponent;
